var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 .4C7.832.4.332 7.883.332 17.1c0 8.333 6.1 15.25 14.066 16.5V21.933h-4.233V17.1H14.4v-3.684c0-4.183 2.484-6.483 6.3-6.483 1.817 0 3.717.317 3.717.317v4.116h-2.1c-2.067 0-2.717 1.284-2.717 2.6V17.1h4.634l-.75 4.833h-3.884V33.6a16.667 16.667 0 0014.067-16.5C33.666 7.883 26.166.4 17 .4z",
    fill: "#fff"
  })));
}
export default SvgFacebookWhite;